import api from './api/axiosConfig';

const instituteService = {
  // Get all institutes with optional filters
  getInstitutes: async (params = {}) => {
    try {
      const response = await api.get('/institutions/institutes/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching institutes:', error);
      throw error;
    }
  },

  // Get a single institute by ID
  getInstitute: async (id) => {
    try {
      const response = await api.get(`/institutions/institutes/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching institute:', error);
      throw error;
    }
  },

  // Create a new institute
  createInstitute: async (instituteData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(instituteData).forEach((key) => {
        if (key === 'images' && Array.isArray(instituteData[key])) {
          instituteData[key].forEach((image) => {
            formData.append('images', image);
          });
        } else if (
          key !== 'images' &&
          instituteData[key] !== undefined &&
          instituteData[key] !== null
        ) {
          formData.append(key, instituteData[key]);
        }
      });

      const response = await api.post('/institutions/institutes/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating institute:', error);
      throw error;
    }
  },

  // Update an institute
  updateInstitute: async (id, instituteData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(instituteData).forEach((key) => {
        if (key === 'images' && Array.isArray(instituteData[key])) {
          instituteData[key].forEach((image) => {
            formData.append('images', image);
          });
        } else if (
          key !== 'images' &&
          instituteData[key] !== undefined &&
          instituteData[key] !== null
        ) {
          formData.append(key, instituteData[key]);
        }
      });

      const response = await api.put(`/institutions/institutes/${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating institute:', error);
      throw error;
    }
  },

  // Delete an institute
  deleteInstitute: async (id) => {
    try {
      const response = await api.delete(`/institutions/institutes/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting institute:', error);
      throw error;
    }
  },

  // Get related institutes
  getRelatedInstitutes: async (instituteId, params = {}) => {
    try {
      const response = await api.get('/institutions/institutes/', { 
        params: {
          ...params,
          exclude: instituteId,
          limit: 4
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching related institutes:', error);
      throw error;
    }
  },
};

export default instituteService;
